import { Link } from "react-router-dom";
import TopicCard from "@/components/feature/TopicCard";
import { topics } from "@/mocks/topics";

export default function HotTopics() {
  const featured = topics[0];
  const rest = topics.slice(1, 5);

  return (
    <section className="w-full bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="flex items-center gap-2 text-xs font-medium tracking-wide text-primary-600">
              <span className="flex h-4 w-4 items-center justify-center">
                <i className="ri-fire-line text-base" />
              </span>
              正在热搜
            </span>
            <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              今日热瓜
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              讨论区里讨论声最大的几条话题，按热度实时更新，点进去就能看到围观群众在聊什么。
            </p>
          </div>
          <Link
            to="/category/variety"
            className="flex cursor-pointer items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700"
          >
            全部话题
            <span className="flex h-4 w-4 items-center justify-center">
              <i className="ri-arrow-right-line text-base" />
            </span>
          </Link>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-6 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <TopicCard topic={featured} variant="featured" />
          </div>
          <div className="flex flex-col gap-4 lg:col-span-5">
            <div className="rounded-card border border-background-200 bg-background-100 p-4 md:p-5">
              <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground-900">
                <span className="flex h-4 w-4 items-center justify-center text-primary-600">
                  <i className="ri-list-check-2 text-base" />
                </span>
                热度攀升中
              </h3>
              <div className="mt-4 flex flex-col gap-4">
                {rest.map((topic) => (
                  <TopicCard key={topic.id} topic={topic} variant="compact" />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}